import { apiClientGeral } from '@/plugins/axios'

export default {
  getCentrosDeCusto() {
    return apiClientGeral().get('/centrodecusto/lazy')
  },
}
